declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

const PIXEL_ID = '26494135110170014'

export function initMetaPixel() {
  if (typeof window === 'undefined') return
  if (window.fbq) {
    // Already initialized, just ensure PageView fires
    window.fbq('track', 'PageView')
    return
  }

  // Initialize fbq function immediately (before script loads)
  const n: any = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []
  window.fbq = n
  window._fbq = n

  // Load the Facebook Pixel script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // Add noscript fallback image (validators look for this)
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)

  // Also add the img directly (noscript won't render in JS-enabled browsers,
  // but some validators check for the img element)
  const fallbackImg = document.createElement('img')
  fallbackImg.height = 1
  fallbackImg.width = 1
  fallbackImg.style.display = 'none'
  fallbackImg.setAttribute('aria-hidden', 'true')
  fallbackImg.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  document.body.appendChild(fallbackImg)

  // Init and fire PageView immediately
  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function trackPageView() {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'El Método de la Pausa Consciente',
      content_type: 'product',
      value: 14.97,
      currency: 'USD',
    })
  }
}

export function trackInitiateCheckout() {
  if (window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      content_name: 'El Método de la Pausa Consciente',
      content_type: 'product',
      value: 14.97,
      currency: 'USD',
    })
  }
}
